import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_ORG_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createProcessFlowDiagramSearch } from 'routes/process-flows/-searchParams'
import { Route as NewRoute } from 'routes/process-flows/diagram'

export const Route = createFileRoute(
  '/process-flows/(deprecated_routes)/$siteID/$diagramID'
)({
  beforeLoad: ({ params }) => {
    const { siteID, diagramID } = params

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        ...createProcessFlowDiagramSearch({
          orgId: prev[SEARCH_PARAM_ORG_ID],
          siteId: siteID,
          diagramId: diagramID,
        }),
      }),
      replace: true,
    })
  },
})
